/*
  card-swatch-preview.js  (Aldo-style instant swap)
  Collection card color swatches: each card embeds a JSON blob (.card-swatch-data)
  with every color's image, hover image, url, rendered price HTML, and availability.
  Clicking a swatch patches the card in place — no network request.
  Delegated + guarded so it binds only once even if the script is included per-card.
*/
(function () {
  if (window.__cardSwatchPreview) return;
  window.__cardSwatchPreview = true;

  function getData(root) {
    var el = root.querySelector('.card-swatch-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('a.card-color-swatch[data-card-swatch]');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();

    var root = sw.closest('.card-wrapper') || sw.closest('product-component');
    var href = sw.getAttribute('href');
    if (!root) { if (href) window.location.href = href; return; }

    var data = getData(root);
    var d = data ? data[sw.dataset.colorId] : null;
    if (!d) { if (href) window.location.href = href; return; }  // fallback: navigate

    // 1) images: [0] primary, [1] hover/secondary
    var imgs = root.querySelectorAll('.card__media img');
    if (imgs[0] && d.image)  { imgs[0].setAttribute('srcset', ''); imgs[0].src = d.image; }
    if (imgs[1] && d.image2) { imgs[1].setAttribute('srcset', ''); imgs[1].src = d.image2; }

    // 2) retarget every product link on the card
    if (d.url) {
      root.querySelectorAll('a[href]').forEach(function (a) {
        if (a.classList.contains('card-color-swatch')) return;
        var h = a.getAttribute('href') || '';
        if (h.indexOf('/products/') !== -1) a.href = d.url;
      });
      // 2b) retarget the mini quick-add (uses data-product-url, not an <a href>)
      //     and clear any pre-fetched modal content so it re-fetches the chosen color
      root.querySelectorAll('[data-product-url]').forEach(function (el) {
        el.setAttribute('data-product-url', d.url);
      });
      var qaInfo = root.querySelector('.quick-add-modal__content-info');
      if (qaInfo) qaInfo.innerHTML = '';
    }

    // 3) price (full rendered markup incl. sale styling)
    if (d.price) {
      var priceEl = root.querySelector('.price');
      if (priceEl) priceEl.outerHTML = d.price;
    }

    // 3b) image badge: set sale/sold-out for this color, or clear it
    root.querySelectorAll('.card__badge').forEach(function (b) {
      b.innerHTML = d.badge || '';
    });

    // 4) move the selected ring
    var list = sw.closest('.card-color-swatches');
    if (list) list.querySelectorAll('.card-color-swatch').forEach(function (s) {
      s.classList.remove('is-selected');
    });
    sw.classList.add('is-selected');
  });
})();
